import React from 'react'
import { useTranslation } from 'react-i18next'

interface UserRewardStateLabelProps {
  presentType: Api.ConvertedPresentTypeId
  isApplicationForm?: 0 | 1 | number
  userRewardState: Api.UserStatus
  /** selectedPresentsDetailData.isApplicationFormRepeat => multiple */
  multiple: boolean
  /** dataCampaign?.type */
  campaignType?: number
  /** selectedPresentsDetailData.entryCount */
  entryCount?: number
}

export const UserRewardStateLabel = ({
  presentType,
  isApplicationForm = 0,
  userRewardState,
  multiple,
  campaignType = 0,
  entryCount = 0,
}: UserRewardStateLabelProps) => {
  const { t } = useTranslation()

  return (
    <>
      <p className="text-xs text-color01">
        {/* 賞品交換は、応募フォームの有無に応じて変化するので要注意 */}
        {presentType === 'Product' && (
          <>
            {isApplicationForm !== 0 ? (
              <>
                {userRewardState === 'CONDITION_NOT_MET' && t('prize.un_acquired', '未獲得')}
                {userRewardState === 'CONDITION_MET' && t('prize.prizes_available', '賞品獲得可能')}
                {userRewardState === 'RECEIVED' && t('prize.applicable', '応募可能')}
                {multiple && campaignType !== 3 && entryCount > 0 ? (
                  <></>
                ) : (
                  <>{userRewardState === 'EXCHANGED' && t('prize.applied', '応募済み')}</>
                )}
              </>
            ) : (
              <>
                {userRewardState === 'CONDITION_NOT_MET' && t('prize.un_acquired', '未獲得')}
                {userRewardState === 'CONDITION_MET' && t('prize.prizes_available', '賞品獲得可能')}
                {userRewardState === 'RECEIVED' && t('prize.exchangeable', '交換可能')}
                {userRewardState === 'EXCHANGED' && t('prize.exchanged', '交換済み')}
              </>
            )}
          </>
        )}
        {presentType === 'Coupon' && (
          <>
            {userRewardState === 'CONDITION_NOT_MET' && t('prize.un_acquired', '未獲得')}
            {userRewardState === 'CONDITION_MET' && t('prize.prizes_available', '賞品獲得可能')}
            {userRewardState === 'RECEIVED' && t('prize.usable', '使用可能')}
            {userRewardState === 'EXCHANGED' && t('prize.used', '使用済み')}
          </>
        )}
        {(presentType === 'Download' ||
          presentType === 'PhotoFrame' ||
          presentType === 'Giftee' ||
          presentType === 'GiftCode') && (
          <>
            {userRewardState === 'CONDITION_NOT_MET' && t('prize.un_acquired', '未獲得')}
            {userRewardState === 'CONDITION_MET' && t('prize.prizes_available', '賞品獲得可能')}
            {userRewardState === 'RECEIVED' && t('prize.acquired', '獲得済み')}
            {userRewardState === 'EXCHANGED' && t('prize.acquired', '獲得済み')}
          </>
        )}
      </p>
      {multiple && campaignType !== 3 && entryCount > 0 && (
        <p className="ml-3 text-xs text-color01">
          {t('reward_detail.applied_unit', '{{n}}口応募済み', {
            unit: entryCount,
          })}
        </p>
      )}
      {/* ポイント減算ラリー & 通常 */}
      {campaignType === 3 && isApplicationForm === 0 && entryCount > 0 && (
        <p className="ml-3 text-xs text-color01">
          {t('reward_detail.exchanged_unit', '{{n}}口交換済み', {
            unit: entryCount,
          })}
        </p>
      )}
      {/* ポイント減算ラリー & 応募フォーム */}
      {campaignType === 3 && isApplicationForm !== 0 && entryCount > 0 && (
        <p className="ml-3 text-xs text-color01">
          {t('reward_detail.applied_unit', '{{n}}口応募済み', {
            unit: entryCount,
          })}
        </p>
      )}
    </>
  )
}
